import { Stack, styled, Tooltip, Typography } from '@mui/material'
import isNil from 'lodash/isNil'
import { ComponentProps } from 'react'
import { usePriceFormatter } from '@omnea-app/fe-i18n/usePriceFormatter'
import { useOrganisationSettingsByName } from '@omnea-app/fe-org-settings/useOrganisationSettings'
import { Price } from '@omnea-app/requests/price'

export type PriceDisplayProps = {
  price: Price
  direction?: ComponentProps<typeof Stack>['direction']
  hideDefaultPrice?: boolean
  hideFrequency?: boolean
  variant?: ComponentProps<typeof Typography>['variant']
  tooltip?: boolean
}

export function PriceDisplay({
  price,
  direction = 'row',
  hideDefaultPrice = false,
  variant,
  hideFrequency,
  tooltip = false,
}: PriceDisplayProps) {
  const { formatPrice } = usePriceFormatter({ hideFrequency })
  const { formattedPrice, formattedDefaultPrice } = formatPrice(price)
  const { organisationSetting: defaultCurrency } = useOrganisationSettingsByName('defaultCurrency')

  const shouldDisplayDefaultPrice =
    !isNil(formattedDefaultPrice) && !hideDefaultPrice && price.currency !== defaultCurrency.defaultCurrency

  return (
    <Stack direction={direction} spacing={1}>
      <Tooltip title={tooltip ? formattedPrice : ''}>
        <Typography variant={variant}>
          {formattedPrice}
          {direction === 'row' && shouldDisplayDefaultPrice && (
            <InlineDefaultPrice>{` (${formattedDefaultPrice})`}</InlineDefaultPrice>
          )}
        </Typography>
      </Tooltip>
      {direction === 'column' && shouldDisplayDefaultPrice && (
        <Tooltip title={tooltip ? formattedDefaultPrice : ''}>
          <Typography color="neutralLight.900" variant="HeaderSubtitleSmallRegular">
            {formattedDefaultPrice}
          </Typography>
        </Tooltip>
      )}
    </Stack>
  )
}

const InlineDefaultPrice = styled('span')(({ theme }) => ({
  color: theme.palette.neutralLight[900],
}))
